import { withLayout } from '../../../layout';

import Apikeys from './api-keys.page';

export default withLayout(Apikeys);
